import React from "react";
import RegisterPageScaffold from "./RegisterPageScaffold";
import { getRegisterVariant } from "./registerPageConfig";
import { useRegister } from "./hooks/useRegister";
import RegisterStandardFormBody from "./components/RegisterStandardFormBody";
import RegisterPageDialogs, { RegisterPageBottomBar } from "./components/RegisterPageDialogs";

const VARIANT_ID = "professionalGuardian";

const Register = () => {
  const reg = useRegister(VARIANT_ID);
  const cfg = getRegisterVariant(VARIANT_ID);

  return (
    <RegisterPageScaffold
      config={cfg}
      minHeight={cfg.minHeight}
      bottomBar={<RegisterPageBottomBar reg={reg} />}
      dialogs={<RegisterPageDialogs reg={reg} />}
    >
      <RegisterStandardFormBody reg={reg} />
    </RegisterPageScaffold>
  );
};

export default Register;
